module.exports = __webpack_public_path__ + "../resources/img/qcells_logo.3cc384b0.png";